import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth, signInWithEmailAndPassword } from '../firebase';
import { useTranslation } from '../contexts/LanguageContext';
import '../App.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { t } = useTranslation();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // onAuthStateChanged u App.js preuzima dalje — nema potrebe za setUser/redirect ovdje
    } catch (err) {
      setError(t('auth.loginError'));
    }
  };

  return (
    <div className="container">
      <h2>{t('auth.loginTitle')}</h2>
      {error && <p className="error-message" role="alert">{error}</p>}
      <form onSubmit={handleLogin} method="post" action="#" aria-label={t('auth.loginAria')}>
        <label htmlFor="login-email" className="sr-only">{t('auth.emailLabel')}</label>
        <input
          id="login-email"
          name="email"
          type="email"
          autoComplete="username"
          inputMode="email"
          spellCheck="false"
          autoCapitalize="none"
          autoCorrect="off"
          required
          placeholder="Email"
          className="input-field"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <label htmlFor="login-password" className="sr-only">{t('auth.passwordLabel')}</label>
        <input
          id="login-password"
          name="password"
          type="password"
          autoComplete="current-password"
          required
          placeholder={t('auth.passwordLabel')}
          className="input-field"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">{t('auth.loginSubmit')}</button>
      </form>
      <p style={{ marginTop: 12, textAlign: 'right' }}>
        <Link to="/forgot-password">{t('auth.forgotPassword')}</Link>
      </p>
    </div>
  );
};

export default Login;
